import React, { useRef, useState } from "react";
import { Link } from "react-router-dom";
import { queryClient } from "../../../utils/queryClient";
import { useMutation, useQuery } from "react-query";
//primereact
import { Skeleton } from "primereact/skeleton";
import { BreadCrumb } from "primereact/breadcrumb";
//components
import Panel from "../../../components/panel/panel";
import Modal from "../../../components/modal/Modal";
import CardVideoTraining from "../../../components/cards/CardVideoTraining";
//services
import { getTrainings } from "../../../services/Trainings/getTrainings";
import { patchTrainings } from "../../../services/Trainings/patchTrainings";
import { useAppContext } from "../../../context/AppContext";

const Housing = () => {
  const videoRef = useRef(null);
  const { permissions } = useAppContext();
  const [content, setContent] = useState();
  const [seconds, setSeconds] = useState([]);
  const [visible, setVisible] = useState(false);
  const [durationComplete, setDurationComplete] = useState("");
  const items = [
    {
      template: () => (
        <Link to={"/trainings"} className="p-breadcrumb-link">
          Treinamentos
        </Link>
      ),
    },
    {
      template: () => (
        <Link to={"/trainings/housing"} className="p-breadcrumb-link">
          Imobiliárias
        </Link>
      ),
    },
  ];
  const home = {
    template: () => (
      <Link to={"/trainings"} className="p-breadcrumb-link">
        <i className="fa fa-home"></i>
      </Link>
    ),
  };
  const { data: dataTrainings, isLoading: isLoadingTrainings } = useQuery({
    queryKey: ["Trainings_housing"],
    queryFn: () => getTrainings("/treinamento_imobiliaria"),
    enabled: !!permissions?.includes("3")
  });
//  // console.log(dataTrainings);

  const { mutateAsync: patchTrainingsFn } = useMutation({
    mutationFn: patchTrainings,
    onSuccess(_, variables) {
      queryClient.setQueryData([`Trainings_broker`], (data) => {
        const updatedData = [...data];
        updatedData.map((classroom) => {
          if (classroom.id === variables.id) {
            classroom.user_progress.percentage = variables.percentage;
            classroom.user_progress.seconds = JSON.stringify(variables.seconds);
            classroom.user_progress.video_stopped_in_time =
              variables.video_stopped_in_time;
          }
          return classroom;
        });
        return updatedData;
      });
    },
    onError(error) {
// console.log(error);
    },
  });

  const calculateMinHour = (HourString) => {
    const hour = HourString.split(":");
    let min = parseInt(hour[0], 10);
    let seg = parseInt(hour[1], 10);
    const secondsTotal = min * 60 + seg;
    const ninetySecondsTotal = secondsTotal * 0.9;
    setDurationComplete(ninetySecondsTotal);
  };

  const selectCard = async (item) => {
    setVisible(true);
    calculateMinHour(item.duration);
    setSeconds(
      item.user_progress.seconds === 0 || item.user_progress.seconds === '0' ? [] : JSON.parse(item.user_progress.seconds)
    );
    setContent({
      id: item.id,
      title: item.name,
      link: item.url,
      seconds: item.user_progress.video_stopped_in_time,
      percentage: item.user_progress.percentage,
    });
  };

  const handleCloseModal = async (item) => {
    setVisible(false);
    if (parseInt(item.percentage) !== 100) {
      if (seconds.length > durationComplete) {
        try {
          const data = {
            id: item.id,
            percentage: 100,
            video_stopped_in_time: 0,
            seconds: [0],
          };
          await patchTrainingsFn(data);
          setSeconds([]);
        } catch (error) {
//          // console.log(error);
        }
      } else {
        if (Array.isArray(seconds)) {
          seconds.sort((a, b) => a - b);
        }
        const percentage = ((seconds.length / durationComplete) * 100).toFixed(
          0
        );
        try {
          const data = {
            id: item.id,
            percentage: percentage,
            video_stopped_in_time:
              seconds[seconds.length - 1] > durationComplete
                ? 0
                : seconds[seconds.length - 1],
            seconds: seconds,
          };
          await patchTrainingsFn(data);
          setSeconds([]);
        } catch (error) {
//          // console.log(error);
        }
      }
    }
  };

  const handleTimeUpdate = () => {
    if(Array.isArray(seconds)){
      if (!seconds.includes(Math.floor(videoRef.current.currentTime))) {
        setSeconds([...seconds, Math.floor(videoRef.current.currentTime)]);
      }  
    }  
  };

  return (
    <>
      <BreadCrumb
        model={items}
        home={home}
        style={{ background: "transparent", border: "none", fontSize: "16px" }}
      />
      <Panel>
        <div className="col-md-12 text-center">
          <h1 className="">
            Treinamento <span className="text-success">Imobiliária</span>
          </h1>
          <h4>Segue abaixo os nossos vídeos de treinamento para Imobiliária</h4>
        </div>
        {isLoadingTrainings ? (
          <div className="row mt-3">
            <div className="col-md-4 my-2">
              <Skeleton width="100%" height="70px"></Skeleton>
            </div>
            <div className="col-md-4 my-2">
              <Skeleton width="100%" height="70px"></Skeleton>
            </div>
            <div className="col-md-4 my-2">
              <Skeleton width="100%" height="70px"></Skeleton>
            </div>
          </div>
        ) : (
          <div className="row mt-3">
            {dataTrainings &&
              dataTrainings.map((video) => {
                return (
                  <div className="col-xl-4 col-md-6 my-2" key={video.id}>
                    <CardVideoTraining
                      title={video.name}
                      onClick={() => selectCard(video)}
                      percentage={video.user_progress.percentage}
                      assisted={
                        video.user_progress.percentage !== 100
                          ? "fa-solid fa-play text-success"
                          : "fa-solid fa-play text-secondary"
                      }
                    />
                  </div>
                );
              })}
          </div>
        )}
      </Panel>

      <Modal
        visible={visible}
        position="center"
        onHide={() => handleCloseModal(content)}
        dynamicTitle={content && content.title}
      >
        <>
          <video
            id="youtube-video"
            ref={videoRef}
            className="w-100"
            controls
            controlsList="nodownload"
            onTimeUpdate={handleTimeUpdate}
          >
            <source
              src={
                content &&
                content.link + `#t=${content && parseInt(content.seconds)}`
              }
              type="video/mp4"
            />
            Seu navegador não suporta a tag de vídeo.
          </video>
        </>
      </Modal>
    </>
  );
};

export default Housing;
